var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6666 22.6666V10.6666L19.9999 5.33331H11.9999L5.33325 10.6666V22.6666C5.33325 24.8758 7.12411 26.6666 9.33325 26.6666H22.6666C24.8757 26.6666 26.6666 24.8758 26.6666 22.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.33331H25.6838C26.1414 5.33331 26.5654 5.57904 26.8009 5.98065L29.1457 9.98065C29.6666 10.8693 29.0412 12 28.0286 12H21.3831C20.468 12 19.6199 11.5085 19.1491 10.7053L16 5.33331Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.33331H6.31613C5.85854 5.33331 5.43451 5.57904 5.19909 5.98065L2.85428 9.98065C2.33332 10.8693 2.95875 12 3.97131 12H10.6168C11.532 12 12.38 11.5085 12.8509 10.7053L16 5.33331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBox);
export default __webpack_public_path__ + "static/media/open_box.16f6be2ee3e183e1422901edf89b39a8.svg";
export { ForwardRef as ReactComponent };